import { useAuth } from '@/providers/AuthProvider';
import { Navigate, useLocation } from 'react-router-dom';
import ComplianceGate from '@/features/compliance/ComplianceGate';

export interface ProtectedRouteProps {
    children?: React.ReactNode;
    allowedRoles?: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <div>Cargando...</div>;
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/access-denied" replace />;
    }

    // Gate de cumplimiento (Ley 1581): bloquea hasta completar perfil y aceptar
    // la Política de Tratamiento vigente.
    return <ComplianceGate>{children}</ComplianceGate>;
};

export default ProtectedRoute;
